import React from 'react'
import { SaveButton, Toolbar } from 'react-admin'

// interface ToolbarProps {
//   setOpenLesson: () => void
//   setOpenWeek: () => void
// }

export const CreateCourseToolbar = (props: any) => {
  return (
    <Toolbar {...props}>
      <SaveButton label="salvar" redirect="list" submitOnEnter={true} />
    </Toolbar>
  )
}
